module.exports = __webpack_public_path__ + "media/images/emblems/Rovray-coat_of_arms-e69db1a98ebe73af5ab6ebad113e1a63.svg";